
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/articles/native-american-history-kids-homes-dwellings",
      function () {
        return require("private-next-pages/articles/native-american-history-kids-homes-dwellings.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/articles/native-american-history-kids-homes-dwellings"])
      });
    }
  